module.exports = __webpack_public_path__ + "img/31.01bf8f01.jpg";